<div class="card">

  <!-- Credentials -->
  <div class="credentials-grid">
    <input class="input-field" placeholder="IP" [(ngModel)]="ip">
    <input class="input-field" placeholder="Username" [(ngModel)]="username">
    <input class="input-field" placeholder="Password" type="password" [(ngModel)]="password">
    <input class="input-field" placeholder="Channel ID" [(ngModel)]="channelId">
  </div>

  <div class="button-row">
    <button class="btn btn-primary" (click)="startStream()" [disabled]="streaming">
      Start Stream
    </button>

    <button class="btn btn-danger" (click)="stop()" [disabled]="!streaming">
      Stop Stream
    </button>
  </div>

  <div class="main-layout">
    <div class="video-container">
      <video #video autoplay muted playsinline controls class="video-player"></video>
      <canvas #overlay class="video-overlay"></canvas>

      <div class="video-hint">
        Draw on the video to select an object to track
      </div>
    </div>

    <!-- Thumbnails panel -->
    <div class="thumbnail-panel">
      <h4 class="panel-title">Detected Instances</h4>

      <div *ngIf="latestDetections().length === 0" class="empty-text">
        No detections yet
      </div>

      <div class="thumbnail-grid">
        <div *ngFor="let d of latestDetections()" class="thumbnail-card">
          <img *ngIf="d.crop_b64" [src]="d.crop_b64" class="thumbnail-image" />
          <div class="thumbnail-info">
            <div class="thumbnail-title">
              {{d.label}}
              <span *ngIf="d.id" class="thumbnail-id">#{{d.id}}</span>
            </div>
            <div class="thumbnail-meta">
              hits: {{d.hits}} age: {{d.age}}
            </div>
            <div class="thumbnail-actions">
              <button class="btn btn-small" (click)="selectThumbnail(d)">Track</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Register Object -->
  <div class="register-panel">
    <h4 class="panel-title">Register Object</h4>

    <input class="input-field full-width" placeholder="Object ID (unique)" [(ngModel)]="objectId" />
    <input class="input-field full-width" placeholder="Label (e.g. person, bag)" [(ngModel)]="objectLabel" />

    <input type="file" multiple accept="image/*" (change)="onFilesSelected($event)" class="file-input" />

    <button class="btn btn-primary full-width"
      (click)="uploadObjectImages()"
      [disabled]="selectedFiles.length === 0">
      Upload Images
    </button>

    <div *ngIf="selectedFiles.length" class="file-count">
      {{ selectedFiles.length }} image(s) selected
    </div>
  </div>

  <!-- Alerts -->
  <div class="alerts-container">
    <div *ngFor="let t of alerts()" class="alert-toast">
      <div class="alert-title">{{t.title}}</div>
      <div class="alert-message">{{t.message}}</div>
    </div>
  </div>

</div>
